









import Vue from 'vue'
import Component from 'vue-class-component'
import {
  STATEMENTS_STORAGE_URL,
  TEMPLATE_VIEW_URL,
  STATEMENT_MESSAGE_TEMPLATE_VIEW_URL,
  STATEMENT_MESSAGE_TEMPLATE_PDF_VIEW_URL
} from '@/constants'
import { NoCache } from '@/decorators/NoCache'

@Component({
  props: {
    src: String,
    name: String,
    type: {
      type: String,
      default: 'statement'
    },
    customStyles: {
      type: String
    }
  },
  watch: {
    type: {
      handler () {
        const component: any = this
        component.reload = true
        component.$nextTick(() => {
          component.reload = false
        })
      }
    }
  }
})
export default class PdfViewer extends Vue {
  reload: boolean = false

  @NoCache
  get url () {
    const src = this.$props.src
    const fileName = this.$props.name ? `${this.$props.name}` : ''
    switch (this.$props.type) {
      case 'statement':
        return `${STATEMENTS_STORAGE_URL}/${fileName}?file=${src}`
      case 'template':
        return `${TEMPLATE_VIEW_URL}/${src}${fileName}`
      case 'statement-message':
        return `${STATEMENT_MESSAGE_TEMPLATE_VIEW_URL}/${src}${fileName}`
      case 'pdf-template':
        return `${STATEMENT_MESSAGE_TEMPLATE_PDF_VIEW_URL}/${src}${fileName}`
      default:
        throw new Error(`Unknown pdf type`)
    }
  }
}
